<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/child'
import PageHeader from '@components/page-header'

import CartsForm from './CartsForm';
import { CommunicationsTable } from 'coryallen-communications';

export default {
  page: {
    title: 'Carts',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout, PageHeader, CartsForm, CommunicationsTable },
  data() {
    return {
      title: 'Carts',
      items: [
        { text: appConfig.title, to: '/', },
        { text: 'Carts', to: '/carts', },
        { text: '', active: true, },
      ],

      tabIndex: 0,

      loading: true,
      item: [],
      filters: {
        paginate: 1,
        page: 1,
        total: 0,
        getmapping: 'yes',
        wheres: {
          id: this.$route.params.id
        },
      },

      communications_loading: true,
      communications_filters: {
        paginate: 50,
        page: 1,
        total: 0,
        types: ['Note', 'Activity'],
        only: '',
        onable_id: this.$route.params.id,
        onable_type: 'coryallen\\Carts\\Models\\Cart',
      },

    }
  },
  created() {
    this.tabIndex = parseInt(window.location.hash.replace('#',''), 10);
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.loading = true;
      this.$http.get('/api/carts/fetch', {params: this.filters}).then(res => {
        // console.log(res);
        if(res.data.data.length == 1) {
          if(!res.data.data[0].content){ res.data.data[0].content = []; }
          this.item = res.data.data[0];
          this.title = this.items[2].text = this.item.name;
        } else {
          $this.$noty.warning("Content could not be found.");
          this.$router.push('/carts');
        }
        this.loading = false;
      }).catch(res => { this.popupErrors(res); this.loading = false; });
    },
    update_cart() {
      if(this.disabled == true) { this.$noty.warning('Disabled'); return; } this.disabled = true;

      this.$http.put('/api/carts/update', this.item).then(res => {
        // console.log(res);
        this.$noty.success("Changes have been saved");
        this.disabled = false;
      }).catch(res => { this.popupErrors(res); this.disabled = false; });
    },
    delete_cart() {
      if(this.disabled == true) { this.$noty.warning('Disabled'); return; } this.disabled = true;
      if(!this.item.id) { this.$noty.warning('ID not found'); this.disabled = false; return; }
      var da_message = 'Are you sure you want to delete this content?';
      var n = this.$noty.error(da_message, { timeout: false, modal: true, type: 'default', layout: 'center', closeWith: ['button'],
        buttons: [
          Noty.button('YES', 'btn btn-block btn-light m-r-5', res2 => {
            this.$http.delete('/api/carts/delete/'+this.item.id).then(res => {
              // console.log(res);
              n.close();
              this.$router.push('/carts');
            }).catch(res => { this.popupErrors(res); this.disabled = false; });
          }, {id: 'button1', 'data-status': 'ok'}),
        ]
      }).on('onClose', () => { this.disabled = false; });
    },
  }
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <b-tabs class="nav-bordered header-nav hide-content" lazy v-model="tabIndex">
      <b-tab><template v-slot:title><span class="spinner-border spinner-border-sm" v-if="loading"></span> Details</template></b-tab>
      <b-tab><template v-slot:title><span class="spinner-border spinner-border-sm" v-if="communications_loading"></span> Notes & Activities</template></b-tab>
    </b-tabs>

    <div v-if="item.id">

      <div class="row mt-3">
        <div class="col-sm-3">
          <div class="card-box">

            <h4 class="font-13 text-uppercase">About :</h4>
            <div class="table-responsive">
              <table class="table table-sm table-px-0">
                <tbody>
                  <tr><th class="border-0">Name :</th><td class="border-0">{{item.name}}</td></tr>
                  <tr><th>Page views :</th><td>{{item.view_count}}</td></tr>
                  <tr><th>Last active :</th><td v-tippy :content="moment(item.last_active).format('lll')">{{moment(item.last_active).fromNow()}}</td></tr>
                  <tr><th>Created on :</th><td v-tippy :content="moment(item.created_at).format('lll')">{{moment(item.created_at).fromNow()}}</td></tr>
                </tbody>
              </table>
            </div>

            <h4 class="font-13 text-uppercase">Sections :</h4>
            <div class="table-responsive">
              <table class="table table-sm table-px-0">
                <tbody>
                  <tr v-for="(sub, sub_i) in item.content" :key="sub_i"><td :class="sub_i == 0 ? 'border-0' : ''">
                    <a class="highlightme" :href="'#anc-'+sub.name.toLowerCase().replace(/ /g,'-').replace(/[^\w-]+/g,'')">{{sub.name}}</a>
                  </td></tr>
                </tbody>
              </table>
            </div>

            <h4 class="font-13 text-uppercase">Defaults :</h4>
            <div class="table-responsive">
              <table class="table table-sm table-px-0">
                <tbody>
                  <tr><td class="border-0">META title</td></tr>
                  <tr><td>META description</td></tr>
                  <tr><td>META keywords</td></tr>
                  <tr><td>META image</td></tr>
                  <tr><td>Header title</td></tr>
                  <tr><td>Header description</td></tr>
                  <tr><td>Header image</td></tr>
                </tbody>
              </table>
            </div>

          </div>
        </div>
        <div class="col-sm-9">

          <div v-show="tabIndex == 0">
            <div class="card-box">
              <b-form @submit.prevent="update_cart">
                <h5 class="mb-3 text-uppercase bg-light p-2"><i class="remixicon-book-open-line mr-1"></i> {{title}} cart details</h5>
                <p class="text-muted small">Create/update cart content on the live site. This section is mostly here to make small changes to wording and SEO.</p>

                <draggable handle=".handle" v-bind="{animation: 200}" v-model="item.content">
                  <transition-group class="row">
                    <div v-for="(sub, sub_i) in item.content" :key="'t'+sub_i" :id="'anc-'+sub.name.toLowerCase().replace(/ /g,'-').replace(/[^\w-]+/g,'')" class="col-lg-6 border-bottom mb-2 py-2">
                      <table class="table table-bordered-right table-hover mb-0 table-centered text-nowrap">
                        <tbody>
                          <tr>
                            <td class="p-0 w-100">
                              <b-form-input v-if="hasRole(['Dev','Admin'])" type="text" v-model="sub.name" placeholder="Enter section name" v-tippy content="Enter section name" required></b-form-input>
                              <input v-else class="form-control" type="text" disabled :value="sub.name">
                            </td>
                            <td class="p-0">
                              <button v-if="hasRole(['Dev','Admin'])" type="button" class="btn btn-outline-light bg-white" @click="item.content.splice(sub_i, 1)" v-tippy content="Delete section"><i class="remixicon-delete-bin-line"></i></button>
                            </td>
                            <td class="p-0">
                              <button v-if="hasRole(['Dev','Admin'])" type="button" class="btn btn-outline-light bg-white handle" v-tippy content="Drag to arrange"><i class="remixicon-drag-move-2-fill"></i></button>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="3" class="p-0">
                              <b-form-textarea rows="1" v-model="sub.content" placeholder="Enter section content" v-tippy content="Enter section content"></b-form-textarea>
                              <small v-if="sub.name == 'META keywords'" class="form-text text-muted">Separate by commas</small>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </transition-group>
                </draggable>
                <div class="">
                  <button type="button" class="btn btn-light" @click="item.content.push({name: '', content: ''})"><i class="remixicon-add-line"></i> Add</button>
                </div>
                <div class="clearfix mt-5">
                  <b-button v-if="hasRole(['Dev','Admin'])" type="button" variant="danger" @click="delete_cart"><i class="remixicon-delete-bin-fill"></i> Delete</b-button>
                  <b-button type="submit" variant="success" class="float-right"><i class="remixicon-save-line"></i> Save</b-button>
                </div>
              </b-form>
            </div>
          </div>

          <div v-show="tabIndex == 1">
            <div class="">
              <CommunicationsTable ref="CommunicationsTable" :filters="communications_filters" :user="user" :name="'title'" @loadchange="(e) => {communications_loading = e}"></CommunicationsTable>
            </div>
          </div>

        </div>
      </div>

    </div>
  </Layout>
</template>
